module.exports = __webpack_public_path__ + "img/littleImg03.2be29be1.gif";